import * as React from 'react';
import { cn } from '../../lib/utils';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface TopBarProps {}

export interface DataGridTopBarContainerProps
  extends React.HTMLAttributes<HTMLDivElement> {
  asChild?: boolean;
}

export const DataGridTopBarContainer = React.forwardRef<
  HTMLDivElement,
  DataGridTopBarContainerProps
>(({ className, children, asChild = false, ...props }, ref) => {
  const Comp = asChild ? React.Fragment : 'div';

  const compProps = asChild
    ? {}
    : {
        ref,
        className: cn(
          'px-3 py-2 text-sm flex items-center break-words whitespace-pre-wrap',
          className
        ),
        ...props,
      };

  return <Comp {...compProps}>{children}</Comp>;
});

DataGridTopBarContainer.displayName = 'DefaultTopBar';
